import { useAddedAssignedUserLeads } from './useAddedAssignedUserLeads';

// shares the advisor has not opened from the bell yet
export const useUnprocessedAddedAssignedUserLeads = () => {
    const { data: leads } = useAddedAssignedUserLeads();
    return (leads ?? []).filter((lead) => !lead.isProcessed);
};
